<scaffold-dialog [title]="data.title" [size]="size">
  <div scaffoldDialogBody>
    <app-view
      *ngIf="view; else loading"
      [items]="view?.data?.content"
      [data]="view_data"
      [info]="view"
    ></app-view>

    <ng-template #loading>
      <div
      class="view-modal-loading-spinner-container"
      >
        <app-loading-dots size="5px"></app-loading-dots>
      </div>
    </ng-template>
  </div>
  <div scaffoldDialogButtons>
    <div></div>
    <button pButton severity="primary" (click)="dialogRef.close()">{{'close'| translation}}</button>
  </div>
</scaffold-dialog>
